module.exports = __webpack_public_path__ + "static/media/no_image.f3bb7e50.svg";